import { SearchSortOrder } from '#server/models';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components';
import { useSortOrderStore } from '@/store';

const getSortOrderKey = (sortOrder?: SearchSortOrder) => {
  if (!sortOrder) {
    return '';
  }

  return [
    sortOrder.type,
    sortOrder.field,
    sortOrder.order,
    sortOrder.nestedPath,
    sortOrder.nestedFilter?.field,
    sortOrder.nestedFilter?.value,
  ]
    .filter(Boolean)
    .join(':');
};

export const SortBy = () => {
  const { actions: sortOrderActions, currentSortOrderSet, activeSortOrder } = useSortOrderStore();
  const sortOptions = currentSortOrderSet ?? [];
  return (
    <Select
      onValueChange={(key) => {
        const found = sortOptions.find((o) => getSortOrderKey(o) === key);
        sortOrderActions.setActiveSortOrder(found!);
      }}
      value={getSortOrderKey(activeSortOrder ?? sortOptions[0])}
    >
      <SelectTrigger className="w-full xl:w-auto">
        <SelectValue placeholder="Sort by" />
      </SelectTrigger>
      <SelectContent>
        {sortOptions.map((option) => (
          <SelectItem key={option.title} value={getSortOrderKey(option)}>
            {option.title}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
